import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { BarChart, Bot, ArrowRight, CheckCircle } from "lucide-react";

const nextStepOptions = [
  {
    title: "Find Quick Wins",
    description: "Review the fastest ways to improve performance.",
    icon: <CheckCircle className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/quick-wins",
  },
  {
    title: "Explore Simple Tools",
    description: "Analyze your campaigns with simplified tools.",
    icon: <BarChart className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/tools-choice",
  },
  {
    title: "Get AI Insights",
    description: "Ask our AI for custom recommendations.",
    icon: <Bot className="w-6 h-6 mr-4 text-primary" />,
    link: "/onboarding/ai-setup",
  },
  {
    title: "Dive into Advanced Features",
    description: "Explore the full power of the 8020agent platform.",
    icon: <ArrowRight className="w-6 h-6 mr-4 text-primary" />,
    link: "/",
  },
];

export const NextStepsCard: React.FC = () => {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button className="bg-blue-600 hover:bg-blue-700 text-white">
          What's Next?
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl">What's Next?</DialogTitle>
          <p className="text-muted-foreground">
            Explore other areas or finish onboarding.
          </p>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          {nextStepOptions.map((option) => (
            <Link
              to={option.link}
              key={option.title}
              className="block hover:bg-gray-50 rounded-lg transition-colors"
            >
              <Card className="border-0 shadow-none hover:shadow-sm transition-shadow">
                <CardContent className="p-4">
                  <div className="flex items-start">
                    {option.icon}
                    <div className="flex-1">
                      <h3 className="font-semibold text-base mb-1">
                        {option.title}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {option.description}
                      </p>
                    </div>
                    <ArrowRight className="w-4 h-4 text-muted-foreground ml-2 mt-1" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};
